import { Link } from 'react-router-dom'

const Documents = () => {
    
    return (
        <>
            <div className='p-[10px] w-[100%] text-black bg-[#14608405]'>
                <h6 className='font-bold mb-[20px] text-[20px]'>
                    Right to Information
                </h6>
                <div className='flex flex-col gap-[5px]'>
                    {/* Replace "/path/to/pdf1.pdf" with the actual path to your PDF */}
                    <Link to="/documents/rti_officers.pdf" target="_blank" download>
                        1. Details of State Public Information Officers, Appellate Authorities, Assistant Public Information Officers Designated at the Directorate of Agriculture, Vikas Bhavan, Thiruvananthapuram under RTI Act 2005
                    </Link>
                    {/* Replace "/path/to/pdf2.pdf" with the actual path to your PDF */}
                    <Link to="/documents/sPIO_office_address.pdf" target="_blank" download>
                        2. Office Address of State Public Information Officers under direct control of Director of Agriculture
                    </Link>
                </div>
                <h6 className='font-bold mt-[20px] mb-[20px] text-[20px]'>
                    Orders
                </h6>
                <div className='flex flex-col gap-[5px]' >
                    {/* Replace "/path/to/pdf3.pdf" with the actual path to your PDF */}
                    <Link to="/documents/proceedings_2007.pdf" target="_blank" download>
                        1. Proceedings of the Director of Agriculture dated 06-01-2007
                    </Link>
                    {/* Replace "/path/to/pdf4.pdf" with the actual path to your PDF */}
                    <Link to="/documents/agri_08_01_duties.pdf" target="_blank" download>
                        2. Agri_08_01. Duties and functions of staff.
                    </Link>
                </div>
            </div>
        </>
    )
}

export default Documents